import React, { Component } from "react";
import { connect } from "react-redux";
import Info from "../shared/Info";
import StaticModal from "../shared/StaticModal";
import {
  addMembers,
  selectAddMember,
} from "../../../state/ducks/loyalty/index";
import Inputmask from "inputmask";
import KvkkModal from "../shared/KvkkModal";
import EminevimLoading from "../shared/EminevimLoading";

class SubmitReference extends Component {
  state = {
    name: "",
    surName: "",
    phone: "",
    text: "",
    kvkkAccepted: false,
    kvkkMetni: "",
    isKvkkModalOpen: false,
    shouldAnimateCard: false,
    isProcessing: false,
    formErrors: {
      name: "",
      surName: "",
      phone: "",
      text: "",
      kvkk: "",
    },
  };

  componentDidMount() {
    this.maskAndRegexInput();
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  maskAndRegexInput() {
    const tel = document.getElementById("tel");

    if (tel != null) {
      Inputmask("(999) 999-99-99").mask(tel);
    }
  }

  clearFieldError = (field) => {
    this.setState((prevState) => ({
      formErrors: {
        ...prevState.formErrors,
        [field]: "",
      },
    }));
  };

  validateForm = () => {
    const { name, surName, phone, text, kvkkAccepted } = this.state;
    const formErrors = {
      name: "",
      surName: "",
      phone: "",
      text: "",
      kvkk: "",
    };

    if (!name.trim()) {
      formErrors.name = "Ad alanı boş bırakılamaz";
    }

    if (!surName.trim()) {
      formErrors.surName = "Soyad alanı boş bırakılamaz";
    }

    const phoneDigits = phone.replace(/\D/g, "");
    if (!phoneDigits) {
      formErrors.phone = "GSM alanı boş bırakılamaz";
    } else if (!/^5[0-9]{2}[0-9]{3}[0-9]{2}[0-9]{2}$/.test(phoneDigits)) {
      formErrors.phone = "GSM formatı kontrol edin.";
    }

    if (!text.trim()) {
      formErrors.text = "Açıklama alanı boş bırakılamaz";
    }

    if (!kvkkAccepted) {
      formErrors.kvkk = "Devam etmek için onaylamalısınız";
    }

    return formErrors;
  };

  addMembers = (event) => {
    event.preventDefault();

    const formErrors = this.validateForm();
    const hasErrors = Object.values(formErrors).some(Boolean);

    if (hasErrors) {
      this.setState({ formErrors });
      return;
    }

    this.setState({
      isProcessing: true,
      formErrors: { name: "", surName: "", phone: "", text: "", kvkk: "" },
    });

    Promise.resolve(
      this.props.addMembers(
        this.state.name,
        this.state.surName,
        this.state.phone.replace(/\D/g, ""),
        this.state.text,
        this.state.kvkkAccepted,
        this.state.kvkkMetni
      )
    ).finally(() => {
      this.setState({ isProcessing: false });
    });
  };

  getKvkk = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ isKvkkModalOpen: true });
  };

  handleKvkkLoaded = (kvkkMetni) => {
    this.setState({ kvkkMetni });
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  renderFormField = (label, icon, control, errorMessage, htmlFor, hasError) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div
        className={`t-resetPassword-inputWrap t-submitDemand-inputWrap${
          hasError ? " t-error" : ""
        }`}
      >
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      {errorMessage ? (
        <p className="t-icinputHatamesajArea t-resetPassword-error">{errorMessage}</p>
      ) : (
        <div className="t-icinputHatamesajArea t-resetPassword-error" aria-hidden="true" />
      )}
    </div>
  );

  renderTextareaField = (label, icon, control, errorMessage, htmlFor, hasError) => (
    <div className="t-resetPassword-field">
      {label && (
        <label htmlFor={htmlFor} className="t-resetPassword-label">
          {label}
        </label>
      )}
      <div
        className={`t-resetPassword-inputWrap t-submitDemand-inputWrap t-submitDemand-inputWrap--textarea${
          hasError ? " t-error" : ""
        }`}
      >
        <div>
          <i className={icon} aria-hidden="true" />
        </div>
        {control}
        <div />
      </div>
      {errorMessage ? (
        <p className="t-icinputHatamesajArea t-resetPassword-error">{errorMessage}</p>
      ) : (
        <div className="t-icinputHatamesajArea t-resetPassword-error" aria-hidden="true" />
      )}
    </div>
  );

  render() {
    const { loyalty } = this.props;
    const { shouldAnimateCard, isProcessing, formErrors, kvkkAccepted } = this.state;

    if (loyalty?.addedMember) {
      return (
        <Info
          header={"Referansınız alınmıştır."}
          body={
            "Referansınız ile ilgili gelişmeleri refaranslarım menüsünden takip edebilirsiniz."
          }
        />
      );
    }

    return (
      <div className="t-submitReference-page" style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Referans Ekle</h1>
              <p className="t-memberInfo-pageSubtitle">
                Yeni referans bilgilerini girerek referans başvurunuzu iletebilirsiniz.
              </p>
            </div>

            <article
              className={`t-memberInfo-card t-memberDetail-header--blue${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >

              <form
                className="t-resetPassword-form t-submitDemand-form t-submitReference-form"
                onSubmit={this.addMembers}
                noValidate
              >
                {this.renderFormField(
                  "Ad",
                  "t-icon-user1",
                  (
                    <input
                      id="ad"
                      name="ad"
                      type="text"
                      placeholder="Ad"
                      maxLength="100"
                      value={this.state.name}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                        this.clearFieldError("name");
                      }}
                    />
                  ),
                  formErrors.name,
                  "ad",
                  Boolean(formErrors.name)
                )}

                {this.renderFormField(
                  "Soyad",
                  "t-icon-user1",
                  (
                    <input
                      id="soyad"
                      name="soyad"
                      type="text"
                      placeholder="Soyad"
                      maxLength="100"
                      value={this.state.surName}
                      onChange={(e) => {
                        this.setState({ surName: e.target.value });
                        this.clearFieldError("surName");
                      }}
                    />
                  ),
                  formErrors.surName,
                  "soyad",
                  Boolean(formErrors.surName)
                )}

                {this.renderFormField(
                  "GSM",
                  "t-icon-phone1",
                  (
                    <input
                      id="tel"
                      name="tel"
                      type="text"
                      placeholder="Cep telefon numarası"
                      value={this.state.phone}
                      onChange={(e) => {
                        this.setState({ phone: e.target.value });
                        this.clearFieldError("phone");
                      }}
                    />
                  ),
                  formErrors.phone,
                  "tel",
                  Boolean(formErrors.phone)
                )}

                {this.renderTextareaField(
                  "Açıklama",
                  "t-icon-bubble1",
                  (
                    <textarea
                      id="aciklama"
                      rows="4"
                      maxLength="1000"
                      placeholder="Açıklama yazınız"
                      value={this.state.text}
                      onChange={(e) => {
                        this.setState({ text: e.target.value });
                        this.clearFieldError("text");
                      }}
                    />
                  ),
                  formErrors.text,
                  "aciklama",
                  Boolean(formErrors.text)
                )}

                <div
                  className={`t-submitDemand-kvkk${
                    formErrors.kvkk ? " t-submitDemand-kvkk--error" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    className="t-kvkkcheckbox"
                    id="onaychecked"
                    checked={kvkkAccepted}
                    onChange={(e) => {
                      this.setState({ kvkkAccepted: e.target.checked });
                      this.clearFieldError("kvkk");
                    }}
                  />
                  <span className="t-submitDemand-kvkkText t-submitReference-kvkkText">
                    <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.getKvkk}>
                      KVKK Taahhütnamesi
                    </a>
                    &apos;ni <strong>ONAYLIYORUM</strong>
                  </span>
                </div>
                {formErrors.kvkk ? (
                  <p className="t-resetPassword-error t-submitDemand-kvkkError">{formErrors.kvkk}</p>
                ) : null}

                <div className="t-resetPassword-actions">
                  <button
                    type="submit"
                    className="t-memberInfo-btn t-memberInfo-btn--primary"
                    disabled={isProcessing}
                  >
                    <span>Referans Gönder</span>
                    <i className="t-icon-arrow-right2" aria-hidden="true" />
                  </button>
                </div>
              </form>
            </article>
          </div>
        </div>

        <StaticModal />
        <div className="row" style={{ height: 30 }} />

        <KvkkModal
          isOpen={this.state.isKvkkModalOpen}
          onClose={this.closeKvkkModal}
          onLoaded={this.handleKvkkLoaded}
        />

        {isProcessing && (
          <div className="t-eminevimLoadingOverlay">
            <EminevimLoading subtext="Referansınız gönderiliyor, lütfen bekleyiniz." compact />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loyalty: selectAddMember(state),
});

const mapDispatchToProps = (dispatch) => ({
  addMembers: (name, surName, phone, text, kvkkIzni, kvkkMetni) =>
    dispatch(addMembers(name, surName, phone, text, kvkkIzni, kvkkMetni)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitReference);
